.i{width:100%;}